<template>
  <div class="project-user-list page-box">
    <query-header
      ref="header"
      :selected="selected"
      :push-list="pushList"
      @add="addHandle"
      @delete="deleteHandle"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              规则名称
            </vs-th>
            <vs-th>
              客户姓名
            </vs-th>
            <vs-th>
              账号
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
            <vs-th>
              更新时间
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.ruleName || '-'}}
              </vs-td>
              <vs-td>
                {{tr.name || '-'}}
              </vs-td>
              <vs-td>
                {{tr.mt4Id}}（{{getType(tr)}}）
              </vs-td>
              <vs-td>
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >{{tr.status ? '启用': '禁用' }}</span>
              </vs-td>
              <vs-td>
                {{tr.remark}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.createTime)}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.updateTime)}}
              </vs-td>
              <vs-td>

                <el-button
                  type="text"
                  v-if="isAuth('wx:mt4Receiver:update')"
                  class=""
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  v-if="isAuth('wx:mt4Receiver:delete')"
                  type="text"
                  class="delete-btn"
                  @click="deleteHandle(tr.id)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add
      :dialog-show="addDialogShow"
      :push-list="pushList"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add>
    <edit
      :form-data="currentRow"
      :push-list="pushList"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import edit from '@/components/sys/mt4Channel/edit'
import add from "@/components/sys/mt4Channel/add";
import queryHeader from "@/components/sys/mt4Channel/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { deleteMt4ChanelConfig } from '@/api/sys/mt4Chanel'
export default {
  name: "index",
  components: {
    add,
    edit,
    queryHeader,
    multipleDeleteDialog,
  },
  data() {
    return {
      author: '',
      category: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {},
      pushList:[],
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.getPushList();
    this.init();
  },
  methods: {
    parseTime,
    getstyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    getType(row){
      switch (row.type){
        case 1:
          return 'MT4账号';
        case 2:
          return 'MT4客户端ID';
      }
    },
    beforeInit(){
      this.url = '/wx/manage/mt4Receiver/list';
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order:'desc'
      }
      let header = this.$refs.header;
      if(header.ruleId){
        this.params.ruleId = header.ruleId;
      }
      if(header.name){
        this.params.name = header.name;
      }
      if(header.mt4Id){
        this.params.mt4Id = header.mt4Id;
      }
      if(header.status !== ''){
        this.params.status = header.status;
      }
      if(header.type){
        this.params.type = header.type;
      }
      return true;
    },
    getPushList(){
      this.$http({
        url: 'wx/manage/spiderArticlePublish/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'order':'desc',
          'channelType':8,
        }
      }).then((data) => {
        if (data.code === 200) {
          this.pushList = data.list.list;

        } else {
          this.pushList = []
        }
      })
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      this.currentRow = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    editUserSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      //需要重置currentRow
      this.currentRow = {};
      this.editDialogShow = false;
    },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteMt4ChanelConfig(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.project-user-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
